export const countrys = [
  {
    label:'China',
    value: 'China',
    children: [
      {
        value: 'Bei Jing (北京市)',
        label: 'Bei Jing (北京市)'
      },{
        value: 'Shang hai (上海市)',
        label: 'Shang hai (上海市)'
      },{
        value: 'Shen Zhen (深圳市)',
        label: 'Shen Zhen (深圳市)'
      },{
        value: 'Jiang Su (江苏省)',
        label: 'Jiang Su (江苏省)'
      },{
        value: 'Zhe Jiang (浙江省)',
        label: 'Zhe Jiang (浙江省)'
      },{
        value: 'Tian Jin (天津市)',
        label: 'Tian Jin (天津市)'
      },{
        value: 'Chong Qing (重庆市)',
        label: 'Chong Qing (重庆市)'
      },{
        value: '河北省',
        label: '河北省'
      },{
        value: '山西省',
        label: '山西省'
      },{
        value: '台湾省',
        label: '台湾省'
      },{
        value: '辽宁省',
        label: '辽宁省'
      },{
        value: '吉林省',
        label: '吉林省'
      },{
        value: '黑龙江省',
        label: '黑龙江省'
      },{
        value: '安徽省',
        label: '安徽省'
      },{
        value: '福建省',
        label: '福建省'
      },{
        value: '江西省',
        label: '江西省'
      },{
        value: '山东省',
        label: '山东省'
      },{
        value: '河南省',
        label: '河南省'
      },{
        value: '湖北省',
        label: '湖北省'
      },{
        value: '湖南省',
        label: '湖南省'
      },{
        value: '广东省',
        label: '广东省'
      },{
        value: '甘肃省',
        label: '甘肃省'
      },{
        value: '四川省',
        label: '四川省'
      },{
        value: '贵州省',
        label: '贵州省'
      },{
        value: '海南省',
        label: '海南省'
      },{
        value: '云南省',
        label: '云南省'
      },{
        value: '青海省',
        label: '青海省'
      },{
        value: '陕西省',
        label: '陕西省'
      },{
        value: '广西壮族自治区',
        label: '广西壮族自治区'
      },{
        value: '宁夏回族自治区',
        label: '宁夏回族自治区'
      },{
        value: '新疆维吾尔自治区',
        label: '新疆维吾尔自治区'
      },{
        value: '内蒙古自治区',
        label: '内蒙古自治区'
      },{
        value: '澳门特别行政区',
        label: '澳门特别行政区'
      },{
        value: '香港特别行政区',
        label: '香港特别行政区'
      }
    ]
  },
  {
    label:'US',
    value: 'US',
  },
  {
    label:'Asia (Non-China)',
    value: 'Asia (Non-China)',
    children: [{
      value: 'Japan',
      label: 'Japan',
    },{
      value: 'Korea',
      label: 'Korea',
    },{
      value: 'India',
      label: 'India',
    },{
      value: 'Israel',
      label: 'Israel',
    },{
      value: 'Australia',
      label: 'Australia',
    },{
      value: 'New Zealand',
      label: 'New Zealand',
    },{
      value: 'Malaysia',
      label: 'Malaysia',
    },{
      value: 'Singapore',
      label: 'Singapore',
    },{
      value: 'Thailand',
      label: 'Thailand',
    },{
      value: 'Other',
      label: 'Other',
    }]
  },
  {
    label:'Europe',
    value: 'Europe',
    children: [{
      value: 'France',
      label: 'France',
    },{
      value: 'Netherlands',
      label: 'Netherlands',
    },{
      value: 'UK',
      label: 'UK',
    },{
      value: 'Spain',
      label: 'Spain',
    },{
      value: 'Finland',
      label: 'Finland',
    },{
      value: 'Italy',
      label: 'Italy',
    },{
      value: 'Austria',
      label: 'Austria',
    },{
      value: 'Russia',
      label: 'Russia',
    },{
      value: 'Sweden',
      label: 'Sweden',
    },{
      value: 'Denmark',
      label: 'Denmark',
    },{
      value: 'Other',
      label: 'Other',
    }]
  },
  {
    label:'Americas',
    value:'Americas',
    children: [{
      value: 'Canada',
      label: 'Canada',
    },{
      value: 'Mexico',
      label: 'Mexico',
    },{
      value: 'Brazil',
      label: 'Brazil',
    },{
      value: 'other',
      label: 'other',
    }]
  }
]


// WEBPACK FOOTER //
// ./src/common/country.js